import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import { useForm } from "react-hook-form";
import Content from "../../layout/content/Content";
import { Block, Col, PreviewAltCard, Row } from "../../components/Component";
import { Form, Offcanvas, OffcanvasBody, OffcanvasHeader } from "reactstrap";

import { createTreatmentAPI, deleteTreatmentAPI, listTreatmentAPI, updateSpecializationAPI, updateTreatmentAPI } from "../../api/master/indes";

import { toast } from "react-toastify";

import { BASE_URL_IMG } from "../../assets/constants";
import MyButton from "../../MyComp/UI/form/MyButton";
import ViewImage from "../../MyComp/UI/modals/ViewImage";
import ConfirmModal from "../../MyComp/UI/modals/ConfirmModal";
import MyInput from "../../MyComp/UI/form/MyInput";
import Status from "../../MyComp/UI/form/Status";
import useLogout from "../../hooks/useLogout";
import Table from "../../MyComp/UI/DataTable/Table";
import DeletModal from "../../MyComp/UI/modals/DeleteModal";
const Treatment = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,

    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: false,
      data: [],
      meta_image: null,
      meta_img: null,
      product_Treatment_img: null,
      product_Treatment_image: null,
      product_images: [],
      productTypeDD: [],
      brandsDD: [],
      categoryDD: [],
      unitDD: [],
      ingredientDD: [],
      diseaseDD: [],
      tableLoading: true,
      isPub: false,
    },
  });
  const logout = useLogout();

  const [isOpen, setIsOpen] = useState(false);
  const [imageOpen, setImageOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
   const [deleteModal, setDeleteModal] = useState(false);
  const [mode, setMode] = useState("Add");
  const isLoading = watch("isLoading");
  const [data, setData] = useState([]);

  const toggleCanvas = () => {
    setIsOpen((prev) => !prev);
    if (isOpen) resetF();
  };

  const selectorCheck = (e) => {
    const updated = data.map((item) => ({ ...item, checked: e.target.checked }));
    setData(updated);
  };

  const handleImageClose = () => {
    setImageOpen(!imageOpen);
  };

  const onSelectChange = (e, id) => {
    const updated = data.map((item) => (item.id === id ? { ...item, checked: e.target.checked } : item));
    setData(updated);
  };
  const tableLoading = watch("tableLoading");

  useEffect(() => {
    getTreatmentList();
  }, []);
  const getTreatmentList = () => {
    listTreatmentAPI()
      .then((res) => {
        if (res.data.status === "expired") {
          setValue("tableLoading", false);
          toast.error(res.data.message);
          logout();
        } else if (res.data.status === true) {
          setData(res.data.data);
          setValue("isLoading", false);
          setValue("tableLoading", false);
        } else {
          setValue("tableLoading", false);
          setData([]);
          resetF();
          setValue("isLoading", false);
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setValue("tableLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  const onFormSubmit = (data) => {
    const body = {
      name: watch("treatment"),
      status: watch("status")?.value,
      ...(mode == "Edit" && { id: watch("selectedRow")?.id }),
    };
    if (mode == "Add") {
      createTreatmentAPI(body)
        .then((res) => {
          //const status = decrypt(res.data.status);
          if (res.data.status === true) {
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            getTreatmentList();
            setIsOpen(false);
            setValue("isLoading", false);
          } else if (res.data.status === false) {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (res.data.status === "expired") {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setValue("isLoading", false);
          toast.error(err?.response?.data?.message);
        });
    }
    if (mode == "Edit") {
      updateTreatmentAPI(body)
        .then((res) => {
          //const status = decrypt(res.data.status);
          if (res.data.status === true) {
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            getTreatmentList();
            setIsOpen(false);
            setValue("isLoading", false);
          } else if (res.data.status === false) {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (res.data.status === "expired") {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setValue("isLoading", false);
          toast.error(err?.response?.data?.message);
        });
    }
  };
  const handleEdit = (row) => {
    window.scrollTo(0, 0);
    setValue("selectedRow", row);
    setIsOpen(true);
    setMode("Edit");
    setValue("treatment", row?.name);
    setValue("status", {
      label: row.status ? "Active" : "InActive",
      value: row.status,
    });
  };
  const handleToggleStatus = (row) => {
    setValue("selectedRow", row);
    setShowModal(true);
  };
   const handleDeleteTreatment= (row) => {
    setValue("selectedRow", row);
    setDeleteModal(true);
  };
 const confirmStatusChange = () => {
    const updatedStatus = !watch("selectedRow").status;
    const body = { id: watch("selectedRow").id, status: updatedStatus };

    setValue("isLoading", true);

    updateTreatmentAPI(body)
      .then((res) => {
        if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else if (res.data.status) {
          toast.success(res.data.message);
          getTreatmentList();
          setShowModal(false);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => toast.error(err?.response?.data?.message))
      .finally(() => setValue("isLoading", false));
  };
   
  const resetF = () => {
    setValue("treatment", null);
    setValue("status", "");
    setMode("Add");
  };
  const onDeleteClick = (item) => {
    const body = {
      id: item?.id,
    };

    deleteTreatmentAPI(body)  
      .then((res) => {
        if (res.data.status === true) {
          toast.success(res.data.message);
          toast.clearWaitingQueue();
          getTreatmentList();
        } else if (res.data.status === false) {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };

  return (
    <>
      <Head title={"Treatment | Master"} />
      <Content>
        {/* <BlockHead size={`sm`}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Manage Products"}
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="">
                <Button
                  color="primary"
                  outline
                  className={`  me-n1`}
                  onClick={() => {
                    setIsOpen((pre) => !pre);
                    resetF();
                  }}
                >
                  <Icon name={isOpen ? "minus" : "plus"} />
                </Button>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead> */}
        <Block>
          <>
            {" "}
            <div className="container my-5 text-center">
              {/* Button to open offcanvas */}

              <Offcanvas isOpen={isOpen} direction="end">
                <OffcanvasHeader toggle={toggleCanvas}>Treatment </OffcanvasHeader>
                <OffcanvasBody>
                  <PreviewAltCard>
                    <Form onSubmit={handleSubmit(onFormSubmit)}>
                      <Row>
                        <Col md="12" className={``}>
                          <MyInput
                            register={register}
                            watch={watch}
                            setValue={setValue}
                            trigger={trigger}
                            errors={errors}
                            title={"Treatment"}
                            name={"treatment"}
                            placeholder={"Enter treatment name"}
                            required
                            min={2}
                            max={50}
                          />
                        </Col>
                        <Col md={`12`}>
                          <Status
                            register={register}
                            watch={watch}
                            setValue={setValue}
                            trigger={trigger}
                            errors={errors}
                          />
                        </Col>
                      </Row>
                      <Col md="12" className={``}>
                        <div className="form-group" style={{ marginTop: "31px" }}>
                          <MyButton isLoading={isLoading} mode={mode} />
                        </div>
                      </Col>
                    </Form>
                  </PreviewAltCard>
                </OffcanvasBody>
              </Offcanvas>

              {/* Offcanvas (Right Side) */}
            </div>
          </>

          <Table
            title="Treatment List"
            data={data}
            publicButton={false}
            columns={[{ key: "name", label: "Name" }]}
            searchKeys={["name"]}
            nameColumn={"name"}
            imageBaseURL={BASE_URL_IMG}
            onEditClick={handleEdit}
            selectorCheck={selectorCheck}
            onSelectChange={onSelectChange}
            statusFilterEnabled={true}
            isOpen={isOpen}
            confirmStatusChange={confirmStatusChange}
            setIsOpen={setIsOpen}
            resetF={resetF}
            handleDeleteTreatment={handleDeleteTreatment}
            handleToggleStatus={handleToggleStatus}
            toggleCanvas={toggleCanvas}
            onDeleteClick={onDeleteClick}
            isLoading={tableLoading}
          />

          {/* <MyDataTable data={data || []} columns={column} title={"Product List"} isLoading={isLoading} /> */}
        </Block>
      </Content>
      <ViewImage url={watch("image_preview")} imageOpen={imageOpen} handleImageClose={handleImageClose} />
      <ConfirmModal
        isOpen={showModal}
        toggle={() => {
          setShowModal(!showModal);
          setValue("isPub", false);
        }}
        onConfirm={confirmStatusChange}
        status={watch("selectedRow")?.status}
        isPub={watch("isPub")}
        data={watch("selectedRow")}
      />
      <DeletModal
  isOpen={deleteModal}
  toggle={() => setDeleteModal(false)}   
  onConfirm={onDeleteClick}     
  data={watch("selectedRow")}            
  isLoading={isLoading}
/>

    </>
  );
};

export default Treatment;
